<mat-chip-list>
  <mat-chip *ngFor="let chip of chips">
    {{chip}}
  </mat-chip>
</mat-chip-list>
